import React from "react";
import { useTable } from "react-table";

function UseTable({ columns, data, name, footerValues, classame }) {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({
      columns,
      data,
    });

  const theadColorDecide = {
    backgroundColor:
      name === "regular-membership" || name === "profit-share"
        ? "#171717"
        : "#ececec",
    color:
      name === "regular-membership" || name === "profit-share"
        ? "#FFFFFF"
        : "#2c2c2c",
  };

  const tfooterColorDecide = {
    backgroundColor: name === "regular-membership" ? "#FFFFFF" : "#ececec",
    color: name === "regular-membership" ? "#000000" : "#2c2c2c",
  };

  const showFooter = name !== "regular-membership" && name !== "profit-share";

  return (
    <div className="tableContainer">
      {data?.length > 0 && (
        <table
          {...getTableProps()}
          className={`table ${classame} ${
            name === "regular-membership" || name === "profit-share"
              ? "fullWith"
              : ""
          }`}
        >
          <thead>
            {headerGroups?.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th
                    {...column.getHeaderProps()}
                    className="tableHead"
                    style={theadColorDecide}
                  >
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows?.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()} className="tableData">
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
          
          {showFooter && name !== "wati-logs" && (
            <tfoot>
              <tr>
                <th className="tableData" style={tfooterColorDecide}>
                  Total
                </th>
                <td className="tableData" style={tfooterColorDecide}>
                  {footerValues?.gross_revenue}
                </td>
                <td className="tableData" style={tfooterColorDecide}>
                  {footerValues?.online}
                </td>
                <td className="tableData" style={tfooterColorDecide}>
                  {footerValues?.cash}
                </td>
                <td className="tableData" style={tfooterColorDecide}>
                  -
                </td>
                <td className="tableData" style={tfooterColorDecide}>
                  {footerValues?.gst}
                </td>
                <td className="tableData" style={tfooterColorDecide}>
                  {footerValues?.net_revenue}
                </td>
                <td className="tableData" style={tfooterColorDecide}>
                  -
                </td>
                <td className="tableData" style={tfooterColorDecide}>
                  {footerValues?.total_wtf_share}
                </td>
                <td className="tableData" style={tfooterColorDecide}>
                  {footerValues?.total_gym_share}
                </td>
                <td className="tableData" style={tfooterColorDecide}>
                  {footerValues?.gst_wtf_facilities}
                </td>
                <td className="tableData" style={tfooterColorDecide}>
                  {footerValues?.bill_raised_gym}
                </td>
              </tr>
            </tfoot>
          )}
        </table>
      )}
    </div>
  );
}

export default UseTable;
